import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResults140625 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 14/06/2025 Results</h3>
      <br />
      <br />


      <div><Link to='/conduct-nitchakarnt'>1. AAT 7759  CPO1.NITCHAKARN THAWORNKAN(Pass with Distinction)---Acquired Rank SHODAN-HO</Link></div>
      <br />
      <div><Link to='/conduct-sanphets'>2. AAT 7761  CPO.SANPHET SUKPRATHUEANG(Pass with Distinction)---Acquired Rank SHODAN-HO</Link></div>
      <br />
      <div><Link to='/conduct-supachais'>3. AAT 7832  CPO1.SUPACHAI SITTIRUK(Pass)---Acquired Rank 3KYU</Link></div>
      <br />
      <div><Link to='/conduct-metapornc'>4. AAT 7833  MS.METAPORN CHIM-IM(Pass with Distinction)---Acquired Rank 3KYU</Link></div>
      <br />
      <div><Link to='/conduct-kanokphonc'>5. AAT 7779  MS.KANOKPHON CHAIYAWONG(Pass with Distinction)---Acquired Rank 3KYU</Link></div>
      <br />
      <div><Link to='/conduct-yanint'>6. AAT 7822  MS.YANIN TAIYANON(Pass)---Acquired Rank 5 KYU</Link></div>
      <br />
      <div><Link to='/conduct-thomasm'>7. AAT 7923  MR.THOMAS MOENKEMEIER(Pass)---Acquired Rank 7KYU</Link></div>
      <br />
      <div><Link to='/conduct-napolp'>8. ATT  7910  MR.NAPOL PITAYAPAT(Pass)---Acquired Rank 7KYU</Link></div>
      <br />
      <div><Link to='/conduct-asdawutc'>9. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(Pass)---Acquired Rank 8KYU</Link></div>
      <br />
      <div><Link to='/conduct-nirunc'>10. AAT 7783  LT.NIRUN CHANTAWARO(Pass)---Acquired Rank 9KYU</Link></div>
      <br />
      <div><Link to='/conduct-thongchomphunutr'>11. AAT 7887  MS.THONGCHOMPHUNUT ROJVIBOONCHAI(Pass)---Acquired Rank 9KYU</Link></div>
      <br />
      <div><Link to='/conduct-natsawittau'>12. AAT 7887  MS.NATSAWITTA UNGPRAPAKORN(Pass)---Acquired Rank 9KYU</Link></div>
      <br />
      <div><Link to='/conduct-tarah'>13. AAT 7887  MS.TARA ROSE HEBBLETHWAITE(Pass)---Acquired Rank 9KYU</Link></div>
      <br />
      <div><Link to='/conduct-sunyal'>14. AAT 7972  CPO1.SUNYA LAEID(Pass)---Acquired Rank 9KYU</Link></div>
      <br />
      <div><Link to='/conduct-jamesrh'>15. AAT 8003  MR.JAMES RICKY HEBBLETHWAITE(Pass)---Acquired Rank 10KYU</Link></div>
      <br />
      <div><Link to='/conduct-natthapony'>16. AAT 8004  MR.NATTHAPON YATAN(Pass)---Acquired Rank 10KYU</Link></div>
      <br />
      <div><Link to='/conduct-crystalmd'>17. AAT 8005  MS.CRYSTAL MARIE DABI(Pass)---Acquired Rank 10KYU</Link></div>
      <br />
      <div><Link to='/conduct-nueas'>18. AAT 8006  MS.NUEA SUDRAK(Pass)---Acquired Rank 10KYU</Link></div>
      <br />
      <div>

        Congratulations Everyone!!
        </div>
        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResults140625;
